import { makeStyles } from "@mui/styles";
import { Theme } from "@mui/material/styles";

const useStyles = makeStyles((theme: Theme) => ({
  container: {
    display: "flex",
    justifyContent: "center",
    alignItems: "flex-start",
    flexDirection: "column",
    borderRadius: "4px",
    padding: "32px",
    background: "#E4F5EC",
    width: "100%",
    letterSpacing: 0,
  },
  firstCol: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    width: "100%",
    marginBottom: "4px",
  },
  leftSide: {
    fontSize: "20px",
    fontWeight: 500,
  },
  percentageSpan: {
    fontWeight: "normal",
    fontSize: "16px",
  },
  rightSide: {},
  secondCol: {
    color: "#353535",
    marginBottom: "32px",
  },
  thirdCol: {
    fontSize: "20px",
    fontWeight: 500,
  },
  forthCol: {
    fontSize: "16px",
    fontWeight: "normal",
    marginBottom: "16px",
  },

  graphlinkMobile: {
    marginBottom: "16px",
  },
}));

export default useStyles;
